import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

import { FloatLabelVariant } from '../ui-types';
import { createGuid } from '../../utils/guid';

export interface AutocompleteItem {
  id: number;
  label: string;
}

@Component({
  selector: 'autocomplete',
  imports: [AutoCompleteModule, FormsModule, IconFieldModule, InputIconModule, FloatLabelModule, ReactiveFormsModule],
  templateUrl: './autocomplete.component.html',
  styleUrl: './autocomplete.component.scss',
})
export class AutocompleteComponent implements OnChanges, OnInit {
  @Input() items: AutocompleteItem[] = [];
  @Input() label: string = '';
  @Input({ required: true }) control!: FormControl;
  @Input() remoteSearch = false;
  @Input() variant?: FloatLabelVariant = 'in';
  @Input() errorMessage?: string;
  @Input() showError?: boolean;
  @Output() searchTerm = new EventEmitter<string>();

  id?: string;
  filteredItems: AutocompleteItem[] | undefined;
  selectedItem?: AutocompleteItem;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.remoteSearch && changes['items']) {
      this.filteredItems = this.items;
    }
  }

  ngOnInit(): void {
    if (this.hasLabel()) {
      this.id = createGuid('autocomplete_field');
      return;
    }
    this.variant = 'over';
  }

  hasLabel(): boolean {
    return !!this.label && this.label.length > 0;
  }

  filter(event: AutoCompleteCompleteEvent) {
    const query = event.query.toLowerCase();

    if (this.remoteSearch) {
      this.searchTerm.emit(event.query ?? '');
      this.filteredItems = [...this.items];
      return;
    }

    this.filteredItems = this.items.filter((item) => item.label.toLowerCase().includes(query));
  }
}
